"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.initialState = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _incentiveActions = require("../actions/incentive-actions");

var _util = require("./util");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  error: '',
  message: '',
  status: '',
  referrerEmail: '',
  referrals: []
};
exports.initialState = initialState;
var incentiveReducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2["default"])(_handleActions, (0, _reduxActions.combineActions)("".concat(_incentiveActions.INCENTIVE_OPEN, "_").concat(_httpActions.REQUEST), "".concat(_incentiveActions.INCENTIVE_PRE_OPEN, "_").concat(_httpActions.REQUEST), "".concat(_incentiveActions.INCENTIVE_STATUS, "_").concat(_httpActions.REQUEST), "".concat(_incentiveActions.INCENTIVE_VERIFY, "_").concat(_httpActions.REQUEST), "".concat(_incentiveActions.INCENTIVE_REFERRAL, "_").concat(_httpActions.REQUEST)), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2["default"])(_handleActions, (0, _reduxActions.combineActions)("".concat(_incentiveActions.INCENTIVE_OPEN, "_").concat(_httpActions.SUCCESS), "".concat(_incentiveActions.INCENTIVE_PRE_OPEN, "_").concat(_httpActions.SUCCESS), "".concat(_incentiveActions.INCENTIVE_STATUS, "_").concat(_httpActions.SUCCESS), "".concat(_incentiveActions.INCENTIVE_VERIFY, "_").concat(_httpActions.SUCCESS)), function (state, _ref) {
  var _ref$payload = _ref.payload,
      status = _ref$payload.status,
      code = _ref$payload.code,
      message = _ref$payload.message;
  return _objectSpread(_objectSpread({}, state), {}, {
    status: status,
    message: code === 200 ? message : '',
    error: code === 200 ? '' : message
  });
}), (0, _defineProperty2["default"])(_handleActions, (0, _reduxActions.combineActions)("".concat(_incentiveActions.INCENTIVE_OPEN, "_").concat(_httpActions.FAILURE), "".concat(_incentiveActions.INCENTIVE_PRE_OPEN, "_").concat(_httpActions.FAILURE), "".concat(_incentiveActions.INCENTIVE_STATUS, "_").concat(_httpActions.FAILURE), "".concat(_incentiveActions.INCENTIVE_VERIFY, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2["default"])(_handleActions, _incentiveActions.INCENTIVE_CACHE_REFERRER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    referrerEmail: action.payload
  });
}), (0, _defineProperty2["default"])(_handleActions, "".concat(_incentiveActions.INCENTIVE_REFERRAL, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    referrals: [].concat((0, _toConsumableArray2["default"])(state.referrals), [action.payload])
  });
}), _handleActions), initialState);
var _default = incentiveReducer;
exports["default"] = _default;